import { Outlet } from "react-router-dom";
import useSentryAppSectionTag from "webshop/hooks/useSentryAppSectionTag";
import useDocumentTitle from "../hooks/useDocumentTitle";
import SuspenseLayout from "./SuspenseLayout";

const AppLayout = () => {
  useDocumentTitle();
  useSentryAppSectionTag();
  // useAuthStateListener(); // Monitor Redux auth state changes
  // usePeriodicAuthCheck(); // Periodic authentication check (5 min)
  // usePeriodicLogout(); // Force logout every 30 minutes

  return (
    <SuspenseLayout>
      <Outlet />
    </SuspenseLayout>
  );
};

export default AppLayout;
